import AbstractComponent from "./abstract-component";
import ContentTitle from "./content-title";
import {config, utils} from "@/tools/pdf";

const {zero} = utils;

/**
 * @param {AbstractComponent[]} data Children objects.
 *
 * @param {Object} options
 *  showVDivider: false
 *  bgColor: #ffffff
 *  title: ""
 *  rowYMargin: 14
 *  pageBreak: null (default) | "before" | "after"
 */
class ContentSection extends AbstractComponent {
  constructor(...args) {
    super(...args);

    const {options: {fullWidth, paddingLeft, paddingRight}} = this;

    // Calc paddings
    this.options.paddingLeft = paddingLeft != null
      ? paddingLeft
      : fullWidth
        ? config.vars.pageMarginL / 2
        : 1;
    this.options.paddingRight = paddingRight != null
      ? paddingRight
      : fullWidth
        ? config.vars.pageMarginR / 2
        : 1;
  }

  getDefaultOptions() {
    return {
      title: '',
      bgColor: null,
      infBottom: false,
      fullWidth: false,
      // Divider
      showVDivider: false,
      VDividerColor: config.vars.colors.lightSilver,
      // Gutter
      gutterV: 20,
      gutterH: 20,
      // Padding
      paddingLeft: null,
      paddingTop: 0,
      paddingRight: null,
      paddingBottom: 0,
      // Margin
      marginTop: 0,
      marginBottom: 0,
      // --
      pageBreak: undefined,
    }
  }

  render() {
    const {options: {pageBreak, title, infBottom, paddingLeft, paddingTop, paddingRight, paddingBottom}} = this;

    return {
      table: {
        widths: ['100%'],
        heights: infBottom && [999],
        body: [
          [
            {
              table: {
                widths: this.getInnerWidths(),
                body: [
                  ['', '', '', ''], // Without this => TypeError: Cannot create property 'positions' on string ''
                  title && [ContentTitle(title, {colSpan: 4})],
                  ...this.renderMidRows(),
                ].filter(Boolean),
              },
              layout: this.getInnerLayout(),
              margin: [paddingLeft, paddingTop, paddingRight, paddingBottom]
            }
          ]
        ]
      },
      pageBreak,
      margin: this.getMargin(),
      layout: this.getLayout(),
    }
  }

  renderMidRows() {
    const out = [];
    const {data, options: {gutterH}} = this;
    const midRowsCount = 2 * Math.round(data.length / 2) - 1;

    for (let i = 0; i < midRowsCount; i++) {
      const isDataRow = i % 2 === 0;

      if (isDataRow) {
        out.push([
          data[i],        // Left Col
          '',             // V Gutter Half
          '',             // V Gutter Half
          i + 1 < (data.length)   // Right Col
            ? data[i + 1]
            : '',
        ])
      } else {
        out.push([{text: '', margin: [0, 0, 0, gutterH], colSpan: 4}])
      }
    }

    return out;
  }

  getInnerWidths() {
    const {options: {gutterV}} = this;
    const gutterHalf = Math.round(gutterV / 2);

    return [
      '*',          // Left Col
      gutterHalf,   // V Gutter Half
      gutterHalf,   // Right Col
      '*',          // Padding Right
    ];
  }

  getMargin() {
    const {options: {fullWidth, marginTop, marginBottom}} = this;

    return [
      fullWidth ? -(config.vars.pageMarginL) : 0,
      marginTop,
      fullWidth ? -(config.vars.pageMarginR) : 0,
      marginBottom
    ]
  }

  getLayout() {
    const {options: {bgColor}} = this;

    return {
      hLineWidth: zero,
      vLineWidth: zero,
      fillColor: () => bgColor,
      paddingLeft: zero,
      paddingRight: zero
    }
  }

  getInnerLayout() {
    const {options: {showVDivider, VDividerColor, title}} = this;
    return {
      // divider
      vLineWidth: showVDivider
        ? ((i) => i === 2 ? 1 : 0)
        : zero,
      vLineColor: () => VDividerColor,
      // h lines
      hLineWidth: zero,
      // card backgrounds
      fillColor: (rowIndex, node, columnIndex) => {
        // nothing on first line
        if (rowIndex === 0 || (title && rowIndex === 1)) {
          return false;
        }

        let isContentRow = true;

        if (title) {
          if (rowIndex % 2 === 1) {
            isContentRow = false;
          }
        } else if (rowIndex % 2 === 0) {
          isContentRow = false;
        }

        if (!isContentRow) {
          return null;
        }

        const isContentCol = [0, 3].indexOf(columnIndex) !== -1;

        if (!isContentCol) {
          return null;
        }

        const contentRowIdx = Math.round(rowIndex / 2);
        const contentColIdx = columnIndex === 0 ? 1 : 2;

        if (contentColIdx * contentRowIdx <= this.data.length) {
          return config.vars.colors.lightGray;
        }
      },
      // paddings
      paddingLeft: zero,
      paddingRight: zero,
      paddingTop: zero,
      paddingBottom: zero,
    }
  }
}

export default ContentSection.asFunction()
